import { PdApiActions, PdApiActionsEnum } from "../actions/pdApiActions";
import { isEscalatorDevPackageInitialState } from "./initialState";

const escalatorDevPackageReducer = (
  state: State.EscalatorDevPackageStatus = isEscalatorDevPackageInitialState,
  action: PdApiActions
): State.EscalatorDevPackageStatus => {
  switch (action.type) {
    case PdApiActionsEnum.SET_DOWNLOADING_ESCALATOR_DEV_PACKAGE: {
      const isDownloading = action.payload;
      return { ...state, isDownloadingEscalatorDevPackage: isDownloading };//check this line
    }
    default:
      return state;
  }
};

export default escalatorDevPackageReducer;
